import { MonthlyProjectionRow, YearData } from '../types';

export const rollupMonthlyToAnnual = (monthlyProjection: MonthlyProjectionRow[]): YearData[] => {
  const totalYears = Math.ceil(monthlyProjection.length / 12);

  return Array.from({ length: totalYears }, (_, yearIdx) => {
    const months = monthlyProjection.slice(yearIdx * 12, (yearIdx + 1) * 12);
    const finalMonth = months[months.length - 1];
    const grossRent = months.reduce((sum, row) => sum + row.grossScheduledRent, 0);
    const egi = months.reduce((sum, row) => sum + row.effectiveRentalIncome + row.otherIncome, 0);
    const expenses = months.reduce((sum, row) => sum + row.propertyTaxes + row.insurance + row.hoa + row.propertyManagement + row.routineMaintenance + row.utilities, 0);
    const noi = egi - expenses;
    const interestPaid = months.reduce((sum, row) => sum + row.interestPaid, 0);
    const principalPaid = months.reduce((sum, row) => sum + row.principalPaid, 0);
    const debtService = months.reduce((sum, row) => sum + row.totalDebtService, 0);
    const appreciation = months.reduce((sum, row) => sum + row.monthlyAppreciation, 0);
    const operatingCashFlowBeforeReserves = months.reduce((sum, row) => sum + row.operatingCashFlowBeforeReserves, 0);
    const capexReserve = months.reduce((sum, row) => sum + row.repairReserve + row.turnoverReserve, 0);
    const operatingCf = months.reduce((sum, row) => sum + row.endingCashFlow, 0);
    const trueReturn = months.reduce((sum, row) => sum + row.monthlyTrueReturn, 0);

    return {
      year: yearIdx + 1,
      months: months.map((row) => row.month),
      grossRent,
      egi,
      expenses,
      noi,
      interestPaid,
      principalPaid,
      debtService,
      appreciation,
      operatingCashFlowBeforeReserves,
      capexReserve,
      operatingCf,
      trueReturn,
      reserveRelease: 0,
      equityFromSale: 0,
      totalCashFlow: operatingCf,
      loanBalance: finalMonth?.remainingLoanBalance || 0,
      cumulativePrincipalPaid: finalMonth?.cumulativePrincipalPaid || 0,
      assumedSalePrice: 0,
      netSaleProceeds: 0,
      coc: 0,
      irr: null,
      moic: 0
    };
  });
};
